export var jobSlidesName = 'jobSlides';
